"use client";

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";

import home from "./routes/home";
import auth from "./routes/auth";
import dashboard from "./routes/dashboard";
import PAGE_404 from "./routes/_404";
import Footer from "./routes/auth/components/footer";
import fetch from "./utils/fetch";
import Cookies from "./utils/cookies";

import { useMetatagStore } from "./store/metatag";
import { useShowErrorFlashStore } from "./store/showErrorFlash";
import { useShowWarningFlashStore } from "./store/showWarningFlash";

const App = () => {
    const metatag = useMetatagStore<any>((state: any) => state.metatag);
    const [currentPage, setCurrentPage] = useState<string>("");
    const showErrorFlash = useShowErrorFlashStore<any>((s: any) => s.showErrorFlash);
    const showWarningFlash = useShowWarningFlashStore<any>((s: any) => s.showWarningFlash);

    useEffect(() => {
        if (window.location.hostname === "vca.yourbackoffice.com.au") {
            window.location.href = "https://vca.ypc.solutions";
            return;
        }

        if (currentPage !== window.location.pathname) {
            const cookie = new Cookies();

            setCurrentPage(window.location.pathname);

            (async () => {
                if ((cookie.get("token") || "") === "") {
                    await new fetch(null, {}, { success: false, error: true }).auth();
                    //
                } else {
                    //
                }
            })();
        }
    });

    return (
        <>
            {" "}
            <HelmetProvider>
                <Helmet>
                    <title>{metatag?.title || "YPC VCA"}</title>
                </Helmet>
                <Router>
                    <Switch>
                        <Route path="/" component={home} exact />
                        <Route path="/login" component={auth} exact />
                        <Route path="/forgot-password" component={auth} exact />
                        <Route path="/reset-password/:id" component={auth} exact />
                        <Route path="/logout" component={auth} exact />
                        <Route path="/dashboard" component={dashboard} />
                        <Route path="/404" render={() => <PAGE_404 footer={<Footer />} />} exact />
                        <Redirect to="/404" />
                    </Switch>
                </Router>
                <div className={showErrorFlash === true ? "error-flash-overlay" : "d-none"}></div>
                <div className={showWarningFlash === true ? "warning-flash-overlay" : "d-none"}></div>
                <ToastContainer />
            </HelmetProvider>
        </>
    );
};

export default App;
